// src/pages/ContactUs.js

import React, { useState, useEffect } from 'react';

function ContactUs() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    company: '',
    country: '',
    interest: '',
    message: ''
  });

  const [isFocused, setIsFocused] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFocus = (name) => {
    setIsFocused({ ...isFocused, [name]: true });
  };

  const handleBlur = (name) => {
    setIsFocused({ ...isFocused, [name]: false });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    const payload = {
      access_key: "de271c99-03f3-4ee1-bb87-140545d6ddbe", // Replace with your Web3Forms Access Key
      subject: `New NAPREV Inquiry from ${formData.company}`,
      from_name: `${formData.firstName} ${formData.lastName}`,
      ...formData
    };

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payload)
      });

      const result = await response.json();

      if (result.success) {
        setSubmitStatus('success');
        setFormData({
          firstName: '', lastName: '', email: '', phone: '', company: '', country: '', interest: '', message: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error("Form submission error:", error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
      
      setTimeout(() => {
        setSubmitStatus(null);
      }, 5000);
    }
  };

  const services = [
    "Financial Management Services",
    "Financial Advisory",
    "Transaction Advisory (M&A)",
    "Capital Raising & Investor Relations",
    "Advanced Cash Flow Management",
    "Growth-Centric Financial Strategy & Modeling",
    "Technology Integration & System Architecture",
    "Risk Management, Governance, & Restructuring",
    "Accounting & Bookkeeping Services",
    "Tax Advisory & Compliance",
    "General Inquiry"
  ];

  const topCountries = [
    "India", "United States", "United Kingdom", "United Arab Emirates", 
    "Singapore", "Australia", "Canada", "Germany", "Other"
  ];

  return (
    <div style={styles.pageWrapper}>
      
      {/* Hero Section */}
      <section style={styles.heroSection}>
        <div style={styles.heroContent}>
          <h1 style={styles.heroTitle}>Get in Touch</h1>
          <p style={styles.heroSubtitle}>
            Partner with Naprev to architect your financial future. Reach out to our leadership team for strategic advisory, outsourcing, and enterprise transformation.
          </p>
        </div>
      </section>

      {/* Main Content Grid */}
      <section style={styles.mainSection}>
        <div style={styles.contentGrid}>
          
          {/* Left Column: Contact Info & Locations */}
          <div style={styles.infoColumn}>
            <div style={styles.infoBlock}>
              <h3 style={styles.infoHeading}>Direct Contact</h3>
              <div style={styles.contactItem}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#E1261C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={styles.icon}>
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline>
                </svg>
                <span style={styles.contactText}>WorkForceUS2016@gmail.com</span>
              </div>
            </div>

            <div style={styles.infoBlock}>
              <h3 style={styles.infoHeading}>Global Offices</h3>
              
              <div style={styles.locationCard}>
                <div style={styles.locationHeader}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#002B49" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={styles.locationIcon}>
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle>
                  </svg>
                  <h4 style={styles.locationTitle}>India (GCC)</h4>
                </div>
                <p style={styles.locationText}>
                  Hyderabad, Telangana<br />
                  India
                </p>
              </div>

              <div style={styles.locationCard}>
                <div style={styles.locationHeader}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#002B49" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={styles.locationIcon}>
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle>
                  </svg>
                  <h4 style={styles.locationTitle}>United States</h4>
                </div>
                <p style={styles.locationText}>
                  Pleasanton, California<br />
                  United States
                </p>
              </div>
            </div>
          </div>

          {/* Right Column: Contact Form */}
          <div style={styles.formColumn}>
            <div style={styles.formCard}>
              <h2 style={styles.formCardTitle}>Send us a Message</h2>
              <form onSubmit={handleSubmit} style={styles.form}>
                
                <div style={styles.row}>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>First Name*</label>
                    <input 
                      type="text" name="firstName" required
                      value={formData.firstName} onChange={handleChange}
                      onFocus={() => handleFocus('firstName')} onBlur={() => handleBlur('firstName')}
                      style={{ ...styles.input, ...(isFocused.firstName ? styles.inputFocused : {}) }} 
                    />
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>Last Name*</label>
                    <input 
                      type="text" name="lastName" required
                      value={formData.lastName} onChange={handleChange}
                      onFocus={() => handleFocus('lastName')} onBlur={() => handleBlur('lastName')}
                      style={{ ...styles.input, ...(isFocused.lastName ? styles.inputFocused : {}) }} 
                    />
                  </div>
                </div>

                <div style={styles.row}>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>Corporate Email*</label>
                    <input 
                      type="email" name="email" required
                      value={formData.email} onChange={handleChange}
                      onFocus={() => handleFocus('email')} onBlur={() => handleBlur('email')}
                      style={{ ...styles.input, ...(isFocused.email ? styles.inputFocused : {}) }} 
                    />
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>Phone Number</label>
                    <input 
                      type="tel" name="phone"
                      value={formData.phone} onChange={handleChange}
                      onFocus={() => handleFocus('phone')} onBlur={() => handleBlur('phone')}
                      style={{ ...styles.input, ...(isFocused.phone ? styles.inputFocused : {}) }} 
                    />
                  </div>
                </div>

                <div style={styles.row}>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>Company Name*</label>
                    <input 
                      type="text" name="company" required
                      value={formData.company} onChange={handleChange}
                      onFocus={() => handleFocus('company')} onBlur={() => handleBlur('company')}
                      style={{ ...styles.input, ...(isFocused.company ? styles.inputFocused : {}) }} 
                    />
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>Country*</label>
                    <select 
                      name="country" required
                      value={formData.country} onChange={handleChange}
                      onFocus={() => handleFocus('country')} onBlur={() => handleBlur('country')}
                      style={{ ...styles.select, ...(isFocused.country ? styles.inputFocused : {}) }}
                    >
                      <option value="">Select Country...</option>
                      {topCountries.map((country, idx) => (
                        <option key={idx} value={country}>{country}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div style={styles.inputGroup}>
                  <label style={styles.label}>Nature of Enquiry*</label>
                  <select 
                    name="interest" required
                    value={formData.interest} onChange={handleChange}
                    onFocus={() => handleFocus('interest')} onBlur={() => handleBlur('interest')}
                    style={{ ...styles.select, ...(isFocused.interest ? styles.inputFocused : {}) }}
                  >
                    <option value="">Select Service Area...</option>
                    {services.map((service, idx) => (
                      <option key={idx} value={service}>{service}</option>
                    ))}
                  </select>
                </div>

                <div style={styles.inputGroup}>
                  <label style={styles.label}>How can we help?*</label>
                  <textarea 
                    name="message" required rows="4"
                    value={formData.message} onChange={handleChange}
                    onFocus={() => handleFocus('message')} onBlur={() => handleBlur('message')}
                    style={{ ...styles.textarea, ...(isFocused.message ? styles.inputFocused : {}) }} 
                  />
                </div>

                {submitStatus === 'success' && (
                  <div style={styles.successMessage}>
                    ✓ Thank you! Your message has been sent successfully.
                  </div>
                )}

                {submitStatus === 'error' && (
                  <div style={styles.errorMessage}>
                    ⚠ There was an error sending your message. Please try again later.
                  </div>
                )}

                <button type="submit" style={styles.submitBtn} disabled={isSubmitting}>
                  {isSubmitting ? 'Submitting...' : 'Submit Inquiry'}
                </button>
              </form>
            </div>
          </div>

        </div>
      </section>

    </div>
  );
}

const styles = {
  pageWrapper: {
    fontFamily: 'Arial, sans-serif',
    backgroundColor: '#F4F7F9',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column'
  },
  heroSection: {
    backgroundColor: '#002B49',
    backgroundImage: 'linear-gradient(135deg, #002B49 0%, #001524 100%)',
    padding: '80px 5%',
    textAlign: 'center',
    color: '#FFFFFF',
    borderBottom: '4px solid #E1261C'
  },
  heroContent: {
    maxWidth: '800px',
    margin: '0 auto'
  },
  heroTitle: {
    fontSize: '42px',
    fontWeight: 'bold',
    marginBottom: '20px',
    letterSpacing: '-0.5px'
  },
  heroSubtitle: {
    fontSize: '18px',
    lineHeight: '1.6',
    color: '#D1D5DB'
  },
  mainSection: {
    padding: '60px 5% 100px',
    flexGrow: 1
  },
  contentGrid: {
    maxWidth: '1200px',
    margin: '0 auto',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '50px',
    alignItems: 'flex-start'
  },
  infoColumn: {
    flex: '1',
    minWidth: '300px',
    display: 'flex',
    flexDirection: 'column',
    gap: '40px'
  },
  infoBlock: {
    backgroundColor: '#FFFFFF',
    padding: '30px',
    borderRadius: '12px',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
    border: '1px solid #E5E7EB'
  },
  infoHeading: {
    fontSize: '22px',
    color: '#002B49',
    marginBottom: '25px',
    fontWeight: 'bold',
    borderBottom: '2px solid #F3F4F6',
    paddingBottom: '10px'
  },
  contactItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
    marginBottom: '20px'
  },
  icon: {
    flexShrink: 0
  },
  contactText: {
    fontSize: '16px',
    color: '#4B5563',
    fontWeight: '500'
  },
  locationCard: {
    marginBottom: '25px',
    padding: '15px',
    backgroundColor: '#F9FAFB',
    borderRadius: '8px',
    borderLeft: '4px solid #002B49'
  },
  locationHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    marginBottom: '8px'
  },
  locationIcon: {
    color: '#002B49'
  },
  locationTitle: {
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#111827',
    margin: 0
  },
  locationText: {
    fontSize: '15px',
    color: '#4B5563',
    lineHeight: '1.5',
    margin: '0 0 0 30px'
  },
  formColumn: {
    flex: '2',
    minWidth: '320px'
  },
  formCard: {
    backgroundColor: '#FFFFFF',
    padding: '40px 50px',
    borderRadius: '16px',
    boxShadow: '0 20px 25px -5px rgba(0, 43, 73, 0.1)',
    border: '1px solid #E5E7EB',
    borderTop: '5px solid #E1261C'
  },
  formCardTitle: {
    fontSize: '28px',
    color: '#002B49',
    marginBottom: '30px',
    fontWeight: 'bold'
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px'
  },
  row: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '20px'
  },
  inputGroup: {
    flex: '1',
    minWidth: '240px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },
  label: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#374151'
  },
  input: {
    padding: '14px 16px',
    borderRadius: '8px',
    border: '1px solid #D1D5DB',
    fontSize: '15px',
    fontFamily: 'inherit',
    backgroundColor: '#F9FAFB',
    transition: 'all 0.3s ease',
    outline: 'none'
  },
  select: {
    padding: '14px 16px',
    borderRadius: '8px',
    border: '1px solid #D1D5DB',
    fontSize: '15px',
    fontFamily: 'inherit',
    backgroundColor: '#F9FAFB',
    transition: 'all 0.3s ease',
    outline: 'none',
    cursor: 'pointer',
    appearance: 'none',
    backgroundImage: `url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23111827%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E")`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right 16px top 50%',
    backgroundSize: '12px auto'
  },
  textarea: {
    padding: '14px 16px',
    borderRadius: '8px',
    border: '1px solid #D1D5DB',
    fontSize: '15px',
    fontFamily: 'inherit',
    backgroundColor: '#F9FAFB',
    transition: 'all 0.3s ease',
    outline: 'none',
    resize: 'vertical'
  },
  inputFocused: {
    borderColor: '#002B49',
    backgroundColor: '#FFFFFF',
    boxShadow: '0 0 0 3px rgba(0, 43, 73, 0.1)'
  },
  submitBtn: {
    marginTop: '15px',
    backgroundColor: '#E1261C',
    color: '#FFFFFF',
    border: 'none',
    padding: '16px',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    boxShadow: '0 4px 6px rgba(225, 38, 28, 0.2)'
  },
  successMessage: {
    backgroundColor: '#DEF7EC',
    color: '#03543F',
    padding: '15px',
    borderRadius: '8px',
    fontSize: '15px',
    fontWeight: '600'
  },
  errorMessage: {
    backgroundColor: '#FDE8E8',
    color: '#9B1C1C',
    padding: '15px',
    borderRadius: '8px',
    fontSize: '15px',
    fontWeight: '600'
  }
};

export default ContactUs;